<div class="compatibility-info-dialog" [className]="company === 'bag' ? 'compatibility-info-dialog bayernwerk' : 'compatibility-info-dialog'">
  <div class="browsers">
    <span class="edge" aria-hidden="true">
      <img src="./assets/icons/edge-brands.svg" alt="edge-brands" />
    </span>
    <span class="fa fa-firefox" aria-hidden="true"></span>
    <span class="fa fa-chrome" aria-hidden="true"></span>
  </div>
  <div class="info">
    <label class="title">
      {{ 'module.modals.compatibiltyInfo.messageTitle2' | translate }}
    </label>
    <p class="message">
      {{ 'module.modals.compatibiltyInfo.messageLine2' | translate }}
    </p>
  </div>
  <span class="fa fa-times" aria-hidden="true" (click)="close()"></span>
</div>
